import React from 'react';

interface Props {
  xStart: number; // xStepLength * i
  width: number; // xStepLength
  color: string;
  drawCycleCount: number;
}
// viewBox={`${xStart} -5 ${width} 180`}
const Vector: React.FC<Props> = (props) => {
  const { xStart, width, color, drawCycleCount } = props;
  const drawCycle = ' c 90 0 90 170 180 170 c 90 0 90 -170 180 -170';
  let drawCycles = '';
  for (let index = 0; index < drawCycleCount; index += 1) {
    drawCycles += drawCycle;
  }
  return (
    <svg
      width={width}
      height="180"
      viewBox={`${xStart} -5 ${width} 180`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d={`M0 0${drawCycles}`} stroke={color} strokeWidth="10" />
    </svg>
  );
};

export default Vector;
